import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
const $= window.$;

class Contacts extends Component {
	constructor(props) {
		super(props);
        this.state={
            contacts:[],
            mails:[],
            checkedValues:[],
            
        };

	}

    componentWillReceiveProps(nextProps) {
    	this.getToAddress();
	}


	getCheck(){
		var checkedValues = $('.chk_slct:checked').map(function() {
			return this.value;
		}).get();

		let mailid = [];
		checkedValues.map((val,i)=>{
			let get = val.split('*#');
			let admin_id = get[0];
			let name = get[1];
			let email = get[2];
			let role = get[3];
			mailid[i] = name+'('+email+')';
		})
			this.setState({
				mails:mailid,
				checkedValues:checkedValues
			})

	}

	slideTog(){
		$(".insert-mail").slideToggle();
	}

	showmail(){
		$(".insert-mail").slideToggle();
		let joined = this.state.mails;
		let AllDatas = this.state.checkedValues;
		if(joined!=undefined){
			joined = joined.join(',');
		}
		this.props.sentData(joined,AllDatas);
	}

	getToAddress(){
		let query_data=Common.objToSlashString({
	      learner_id:Common.getUserData("id", true),
	      product_id:Common.getUserData("productID", true),
	      pin_id:Common.getUserData('pinID', true),
	      pin_no:Common.getUserData('pinNo', true),
	     });

	     fetch(Config.domainUrl+'message-contacts/view'+query_data, {
	       method: 'GET',
	       headers: {
	         'Accept': 'application/json',
	         'Content-Type': 'application/json',
			 'Authorization':'Bearer ' +Common.getTokenData()
	       }
	     }).then((response) => response.json()).then((responseJson) => {
	     	//alert(JSON.stringify(responseJson));
	      if(responseJson.status==1){

	        this.setState({contacts:responseJson.data});
	      }

	       //Common.reactLoader("hide");
	     });
	}
   

    componentDidMount() {
    	this.getToAddress();
    }




		render() {

			//alert(JSON.stringify(this.state.mails))
			//let contact = '';
			let contact_add =null;
			if(this.state.contacts!=undefined){
				
				contact_add= this.state.contacts.map((lists,i)=>{

					if(lists.contact!=undefined){

						let list = lists.contact.map((con,k)=>{
							return(
									<ul key={`li_${k}`}>
										<li>
											<span><input type="checkbox" name={"cn_"+k} id={"cn_"+k} value={con.id+'*#'+con.name+'*#'+con.email+'*#'+lists.role} className="chk_slct" onClick={(e)=>this.getCheck(e)} /></span>{con.name}
										</li>
									</ul>
								)
						}) 
						return(
								<div key={`con_${i}`} className={lists.class}>
									<span dangerouslySetInnerHTML={{__html: lists.title}}/>
									{(list)?list:'No '+lists.notitle+' found'}
								</div>
							)
					}

				})
			}

			
			return (
				<div id="contact_form" >
					<h2>Contacts</h2>
					<div className="insert-mail-cont">
						{contact_add}
						<div className="insert-cont-lft insert-cont-lft-btn">	 
							<input className="button-accept" type="button" name="btnInsert" id="btnInsert" value="Insert address" alt="Insert address" title="Insert address" onClick={(e)=>this.showmail(e)} />
						     <input className="button-cancel" type="button" name="btnInsert" id="btnInsert" value="Cancel" alt="Cancel" title="Cancel" onClick={(e)=>this.slideTog(e)}/>
						</div>
					</div>
				</div>
			);
		}
}

export default Contacts;



// WEBPACK FOOTER //
// ./src/personal_interactions/messages/Contacts.js